/*  ----------  CENTRAL SINGLE SOURCE OF TRUTH  ----------  */

export type Distributor = {
    AccountID: string
    Name: string
    ContactInfo: string
    Region: string
    BusinessName: string
  
    /* detail‑screen fields */
    Address: string
    ImageUrl: string
  
    /* KPI fields */
    TotalOpenOrderValue: number   // $ value of *open* POs
    Units: number                 // units still open
    BalanceDue: number            // still‑unpaid balance
    OpenOrders: number            // open PO count
  
    /* NEW metrics */
    YTDSales: number              // year‑to‑date sales $
    TotalOrders: number           // # of orders booked YTD
  }
  
  /* ----------  CARIBBEAN  ---------- */
  
  export const caribbeanDistributors: Distributor[] = [
    {
      AccountID: '1',
      Name: 'Vero Aguilar',
      ContactInfo: '209‑847‑9592',
      Region: 'Puerto Rico',
      BusinessName: 'SunnyShades LLC',
      Address: '1074 José E. Arraras St #2, Mayagüez, PR 00680',
      ImageUrl: '/media/profile/randomguy.jpg',
      TotalOpenOrderValue: 240_000,
      Units: 8_123,            // was 8_000
      BalanceDue: 18_400,
      OpenOrders: 12,
      YTDSales: 1_050_000,
      TotalOrders: 175,
    },
    {
      AccountID: '2',
      Name: 'Jamie Torres',
      ContactInfo: '787‑555‑0147',
      Region: 'Puerto Rico',
      BusinessName: 'IslandEyewear Inc.',
      Address:
        '1502 Ponce de León, Santurce, 00909, San Juan, Puerto Rico',
      ImageUrl: '',
      TotalOpenOrderValue: 210_000,
      Units: 7_218,           // was 7_000
      BalanceDue: 15_750,
      OpenOrders: 10,
      YTDSales: 920_000,
      TotalOrders: 148,
    },
    {
      AccountID: '3',
      Name: 'Luisa Martínez',
      ContactInfo: '787‑555‑0234',
      Region: 'Puerto Rico',
      BusinessName: 'CoastalViews Optics',
      Address: '18 Calle San José, San Juan, 00901, Puerto Rico',
      ImageUrl: '',
      TotalOpenOrderValue: 270_000,
      Units: 9_134,           // was 9_000
      BalanceDue: 22_000,
      OpenOrders: 15,
      YTDSales: 1_210_000,
      TotalOrders: 200,
    },
    {
      AccountID: '4',
      Name: 'Roberto Vazquez',
      ContactInfo: '787‑555‑0333',
      Region: 'Puerto Rico',
      BusinessName: 'Visionary Lenses PR',
      Address: 'Calle Loiza 1765, San Juan, 00911, Puerto Rico',
      ImageUrl: '',
      TotalOpenOrderValue: 245_880,
      Units: 8_321,           // was 8_196
      BalanceDue: 19_800,
      OpenOrders: 13,
      YTDSales: 1_030_000,
      TotalOrders: 161,
    },
  ]
  
  /* ----------  ISRAEL  ---------- */
  
  export const israelDistributors: Distributor[] = [
    {
      AccountID: '5',
      Name: 'Yael Cohen',
      ContactInfo: '03‑555‑0147',
      Region: 'Tel Aviv',
      BusinessName: 'OpticCity Ltd.',
      Address: 'Ha‑Yarkon St 88, Tel Aviv',
      ImageUrl: '',
      TotalOpenOrderValue: 255_000,
      Units: 8_452,           // was 8_500
      BalanceDue: 20_400,
      OpenOrders: 14,
      YTDSales: 1_180_000,
      TotalOrders: 186,
    },
    {
      AccountID: '6',
      Name: 'Eitan Levy',
      ContactInfo: '03‑555‑0923',
      Region: 'Tel Aviv',
      BusinessName: 'Visionary Frames Ltd.',
      Address: 'Ben Yehuda St 45, Tel Aviv',
      ImageUrl: '',
      TotalOpenOrderValue: 228_000,
      Units: 7_593,           // was 7_600
      BalanceDue: 17_100,
      OpenOrders: 12,
      YTDSales: 980_000,
      TotalOrders: 153,
    },
    {
      AccountID: '7',
      Name: 'Noa Mizrahi',
      ContactInfo: '02‑655‑0182',
      Region: 'Jerusalem',
      BusinessName: 'Jerusalem Optics Co.',
      Address: 'King George St 23, Jerusalem',
      ImageUrl: '',
      TotalOpenOrderValue: 186_000,
      Units: 6_234,           // was 6_200
      BalanceDue: 13_900,
      OpenOrders: 9,
      YTDSales: 770_000,
      TotalOrders: 119,
    },
    {
      AccountID: '8',
      Name: 'Amir Rosen',
      ContactInfo: '08‑643‑9872',
      Region: 'South District',
      BusinessName: 'Desert View Eyewear Ltd.',
      Address: 'Herzl St 67, Beersheba',
      ImageUrl: '',
      TotalOpenOrderValue: 210_000,
      Units: 7_122,           // was 7_000
      BalanceDue: 15_600,
      OpenOrders: 11,
      YTDSales: 890_000,
      TotalOrders: 141,
    },
    {
      AccountID: '9',
      Name: 'Tamar Schwartz',
      ContactInfo: '04‑853‑2345',
      Region: 'Haifa',
      BusinessName: 'Haifa Sightline Optics Ltd.',
      Address: 'Hahistadrut Blvd 12, Haifa',
      ImageUrl: '',
      TotalOpenOrderValue: 246_000,
      Units: 8_051,           // was 8_200
      BalanceDue: 19_200,
      OpenOrders: 13,
      YTDSales: 1_020_000,
      TotalOrders: 158,
    },
    {
      AccountID: '10',
      Name: 'Omer Katz',
      ContactInfo: '09‑852‑4567',
      Region: 'Central District',
      BusinessName: 'ClearVision Optics Ltd.',
      Address: 'Weizmann St 88, Netanya',
      ImageUrl: '',
      TotalOpenOrderValue: 311_490,
      Units: 10_383,          // kept unique
      BalanceDue: 24_900,
      OpenOrders: 17,
      YTDSales: 1_370_000,
      TotalOrders: 212,
    },
  ]
  
  export {}
  